var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectedCheckmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0z",
  fill: "#46CC88"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.878 6.18-6.67 6.24-3.085-2.888a.667.667 0 0 0-.911.973l3.542 3.314a.665.665 0 0 0 .91 0l7.126-6.666a.667.667 0 1 0-.912-.973z",
  fill: "#FFF"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectedCheckmark);
export default ForwardRef;